import React, { useState, useEffect } from "react";
import { Box, VStack, Textarea, Button } from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import JSONModal from "../JSONModal";

interface FileUploadComponentProps {
  onFileLoad: (jsonData: any, values: any) => void;
  setInitialValues?: any;
  initialValues?: any;
  values?: any;
}

const JsonFileUpload: React.FC<FileUploadComponentProps> = ({
  onFileLoad,
  setInitialValues,
  initialValues,
  values
}) => {
  const [jsonModels, setJsonModels] = useState({open : false , data : {}})
  const initialFileContent = initialValues?.schema ? Object.keys(initialValues?.schema).length > 0
    ? JSON.stringify(initialValues.schema, null, 2) : "{}"
    : "{}";

  const [fileContent, setFileContent] = useState<string>(initialFileContent);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target?.result as string;
        try {
          const jsonData = JSON.parse(content);
          setFileContent(JSON.stringify(jsonData, null, 2));
          onFileLoad(jsonData, values);

          if (setInitialValues) {
            setInitialValues((prev: any) => ({ ...prev, schema: jsonData }));
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
          setFileContent("Invalid JSON content.");
        }
      };
      reader.readAsText(file);
    }
  };

  const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const content = event.target.value;
    setFileContent(content);
    try {
      const jsonData = JSON.parse(content);
      onFileLoad(jsonData, values);
    } catch (error) {
      console.error("Error parsing JSON:", error);
      // Optional: Display an error message or highlight invalid JSON
    }
  };

  console.log('testing console')

  return (
    <Box>
      <VStack spacing={4} mt={4}>
        <CustomInput
          // label="Upload Schema JSON"
          name="json"
          type="file"
          rest={{ accept: ".json" }}
          onChange={handleFileUpload}
        />
        <Button onClick={() => {
          setJsonModels(() => ({...jsonModels, open : true, data : jsonModels.data}))}} display="none">CREATE JSON</Button>
        <Textarea
          value={fileContent}
          placeholder="File content will be displayed here..."
          onChange={handleContentChange}
          rows={10}
          width="100%"
          isReadOnly={true}
        />
      </VStack>
      {jsonModels.open && <JSONModal defaultSchema={JSON.parse(fileContent)} isOpen={jsonModels.open} onClose={() => {
        setJsonModels(() => ({...jsonModels, open : false}))
      }}/>}
    </Box>
  );
};

export default JsonFileUpload;
